var React = require('react');

function WarningFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.184 2.919a5.218 5.218 0 00-9.367.001L.477 42.317A4.636 4.636 0 004.64 49h39.72a4.638 4.638 0 004.164-6.684L29.184 2.92zm-3.153 13.925a1.531 1.531 0 10-3.062 0v15.313a1.531 1.531 0 103.062 0V16.845zM24.5 36.75a2.297 2.297 0 100 4.594 2.297 2.297 0 000-4.594z"}));
}

WarningFilled.defaultProps = {"viewBox":"0 0 49 49"};

module.exports = WarningFilled;

WarningFilled.default = WarningFilled;
